import { useState } from "react";
import { Link } from "react-router-dom";
import { BarChart3, Check, Coins, Grid3x3, Link2, Users } from "lucide-react";

const ICON_STYLE = "text-nx-mute transition-colors duration-200 group-hover:text-nx-lime";

export const QuickActions = ({ accountId }) => {
    const [copied, setCopied] = useState(false);
    const copyRef = async () => {
        try {
            await navigator.clipboard.writeText(`https://www.nexora-global.io/?ref=${accountId}`);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {}
    };

    const linkCls =
        "group inline-flex shrink-0 items-center gap-2 rounded-lg border border-white/5 bg-nx-alt px-3.5 py-2.5 text-xs font-bold text-nx-sub transition-colors duration-200 hover:border-white/15 hover:text-nx-text";

    return (
        <div className="mt-6 flex gap-2 overflow-x-auto pb-1" data-testid="quick-actions" role="navigation" aria-label="Quick actions">
            <button type="button" onClick={copyRef} data-testid="quick-action-personal-link" className={linkCls}>
                {copied ? <Check size={14} strokeWidth={2} className="text-nx-lime" aria-hidden="true" /> : <Link2 size={14} strokeWidth={1.5} className={ICON_STYLE} aria-hidden="true" />}
                {copied ? "Copied" : "Personal Link"}
            </button>
            <Link to="/dashboard/team" data-testid="quick-action-team" className={linkCls}>
                <Users size={14} strokeWidth={1.5} className={ICON_STYLE} aria-hidden="true" />
                Team
            </Link>
            <Link to="/dashboard/matrix" data-testid="quick-action-matrix" className={linkCls}>
                <Grid3x3 size={14} strokeWidth={1.5} className={ICON_STYLE} aria-hidden="true" />
                Matrix
            </Link>
            <Link to="/dashboard/tokens" data-testid="quick-action-tokens" className={linkCls}>
                <Coins size={14} strokeWidth={1.5} className={ICON_STYLE} aria-hidden="true" />
                Tokens
            </Link>
            <Link to="/dashboard/stats" data-testid="quick-action-stats" className={linkCls}>
                <BarChart3 size={14} strokeWidth={1.5} className={ICON_STYLE} aria-hidden="true" />
                Stats
            </Link>
        </div>
    );
};
